// extracted by mini-css-extract-plugin
export default {"root":"bJWOS","heading-and-subheading-block":"_31KVT","headingAndSubheadingBlock":"_31KVT","subheading":"qaEBX"};